import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/timer'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/take'
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {

  @Input() timeCounter: number;

 
  
  countDown;
  counter = 120;
  tick = 1000;
  ngOnInit() {
    console.log("timeCounter",this.timeCounter)
    if(this.timeCounter == undefined || this.timeCounter == null){
      this.counter = 120
    }
    else{
      this.counter = this.timeCounter
    }
    this.countDown = Observable.timer(0, this.tick)
      .take(this.counter)
      .map(() => --this.counter)
  }
}

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipes implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

}
